angular
    .module('claimVic.controller')
    .controller('claimSummaryVicController', ['$q', '$scope', '$rootScope', '$filter', '$controller', '$timeout', 'httpService', 'policyService', 'commonService', 'commonConst', 'policySumm',
        function ($q, $scope, $rootScope, $filter, $controller, $timeout, httpService, policyService, commonService, commonConst, policySumm) {

            $scope.init = function () {
                $controller('homeController', { $scope: $scope });

                $scope.isDisableBackButton = true;
                //Number of option in filter
                $scope.rowPerPage = 10;
                $scope.VicBusinessUnitSuffix = '2';
                $rootScope.claimsPageSelected;
                $scope.Claims;
                $scope.serverResponse;
                $scope.claimSearchString = '';
                $scope.isSearchClaim = false;
                $scope.allowSpecial = '"&\'()-./';
                $scope.employerId = ($rootScope.pageNavigationHistory.policy != null) ? $rootScope.pageNavigationHistory.policy.PolicyId : null;
                $scope.Scheme = ($rootScope.pageNavigationHistory.policy != null) ? $rootScope.pageNavigationHistory.policy.Scheme : null;
                
                $scope.pageName = "My Claims Summary";
                $scope.pageBreadcrumbs = [{url: '/', title: 'Home'}, {url: '#', title: 'My Policies & Claims', action: 'openSelectPolicyForVicClaim()'}, {url: null, title: 'My Claims Summary'}];
                
                //remove Breadcrumbs My Policies & Claims if worker or NSI
                if ($rootScope.user.IsClaimant || $scope.Scheme === 1 || $rootScope.previousPolicyCount === 1) {
                    $scope.pageBreadcrumbs.splice(1, 1);   
                } else {
                    if((typeof($rootScope.previousPolicyCount) === "undefined" || $rootScope.previousPolicyCount === null)) {
                        policySumm.getPolicyCount(1).then(function(policyCount) {
                            $rootScope.previousPolicyCount = policyCount;
                            if ($rootScope.previousPolicyCount === 1) {
                                $scope.pageBreadcrumbs.splice(1, 1);  
                            }
                        });
                    }
                }

                $scope.oldWorkPlaceNumberSearch = '';
                $scope.oldWorkPlaceNameSearch = '';

                $scope.allWorkPlace = [];
                $scope.allWorkPlaceNumber = [];
                $scope.allWorkPlaceName = [];
                $scope.workPlaceNumber = [];
                $scope.workPlaceName = [];
                $scope.claimStatus = [];
                $scope.claimType = [];
                $scope.costCentre = [];

                $scope.selectedWorkPlaceNumber = [];
                $scope.selectedWorkPlaceName = [];
                $scope.selectedClaimStatus = [];
                $scope.selectedClaimType = [];
                $scope.selectedCostCentre = [];

                $scope.isAnyStatusSelected = false;
                $scope.isAnyTypeSelected = false;
                $scope.isAnyWorkplaceNumber = false;
                $scope.isAnyWorkplaceName = false;

                $scope.statsWPNumber = {};
                $scope.statsWPName = {};

                $scope.stateWPNumberSearch = [];
                $scope.stateWPNameSearch = [];

                $scope.rowSelections = commonConst.ROWS_PER_PAGE_ITEMS;

                $scope.jurisdiction = $filter('dec2arr')(sessionStorage.BusinessUnit, parseInt);
                $scope.jurisdictionCount = $scope.jurisdiction ? $scope.jurisdiction.length : 0;
                $scope.selectedJurisdiction = $rootScope.getSelectedJurisdiction();

                initClaimStatusTooltip();

                policyService.getPolicyDetailForVic($scope.employerId).then(function (response) {
                    $scope.policy = response;

                    // replace in home.js viewClaimSummary
                    sessionStorage.Policy = $filter('enstr64')(JSON.stringify(response));

                    $scope.getClaimStatusAndType().then(function (response) {
                        $scope.searchWorkPlace('').then(function (response) {

                            $scope.allWorkPlaceNumber = $scope.allWorkPlace;
                            $scope.allWorkPlaceName = $scope.allWorkPlace;
                            $scope.lstCostCentre = $scope.getCostCentre();

                            if ($rootScope.pageNavigationHistory.statsWPNumber == null) //go directly from select claim or summary page
                            {


                                $scope.workPlaceNumber = $scope.clientSearchWorkPlace($scope.oldWorkPlaceNumberSearch, true);
                                $scope.workPlaceName = $scope.clientSearchWorkPlace($scope.oldWorkPlaceNameSearch, false);

                                $scope.selectedWorkPlaceNumber = $scope.allWorkPlaceNumber;
                                $scope.selectedWorkPlaceName = $scope.allWorkPlaceName;
                                $scope.selectedClaimStatus = $scope.claimStatus;
                                $scope.selectedClaimType = $scope.claimType;
                                $scope.selectedCostCentre = [];


                                var wpNumberState = $scope.CreateFilterState($scope.workPlaceNumber, [], $scope.oldWorkPlaceNumberSearch, 0);
                                var wpNameState = $scope.CreateFilterState($scope.workPlaceName, [], $scope.oldWorkPlaceNameSearch, 1);

                                $scope.statsWPNumber[$scope.workPlaceNumber] = wpNameState;
                                $scope.statsWPName[$scope.workPlaceName] = wpNumberState;

                                $scope.stateWPNumberSearch = wpNumberState;
                                $scope.stateWPNameSearch = wpNameState;

                                $scope.getClaimList($scope.employerId, 1, $scope.allWorkPlaceNumber, $scope.allWorkPlaceName).then(function () {
                                    $scope.BindFilterControl();
                                });
                            }
                            //Back from claim detail page
                            else {
                                $scope.claimSearchString = ($rootScope.pageNavigationHistory.claimSearchString == undefined || $rootScope.pageNavigationHistory.claimSearchString == null) ? '' : $rootScope.pageNavigationHistory.claimSearchString
                                $scope.isSearchClaim = $scope.claimSearchString ? true : false;
                                $scope.statsWPNumber = $rootScope.pageNavigationHistory.statsWPNumber;
                                $scope.statsWPName = $rootScope.pageNavigationHistory.statsWPName;

                                $scope.workPlaceNumber = $rootScope.pageNavigationHistory.workPlaceNumber;
                                $scope.workPlaceName = $rootScope.pageNavigationHistory.workPlaceName;

                                $scope.selectedWorkPlaceNumber = $rootScope.pageNavigationHistory.selectedWorkPlaceNumber;
                                $scope.selectedWorkPlaceName = $rootScope.pageNavigationHistory.selectedWorkPlaceName;
                                $scope.selectedClaimStatus = $rootScope.pageNavigationHistory.selectedClaimStatus;
                                $scope.selectedClaimType = $rootScope.pageNavigationHistory.selectedClaimType;
                                $scope.selectedCostCentre = $rootScope.pageNavigationHistory.selectedCostCentre;

                                $scope.oldWorkPlaceNumberSearch = $rootScope.pageNavigationHistory.oldWorkPlaceNumberSearch;
                                $scope.oldWorkPlaceNameSearch = $rootScope.pageNavigationHistory.oldWorkPlaceNameSearch;

                                var wpNumberState = $scope.CreateFilterState($scope.workPlaceNumber, $scope.selectedWorkPlaceNumber, $scope.oldWorkPlaceNumberSearch, 0);
                                var wpNameState = $scope.CreateFilterState($scope.workPlaceName, $scope.selectedWorkPlaceName, $scope.oldWorkPlaceNameSearch, 1);
                                var statusState = $scope.CreateFilterState($scope.claimStatus, $scope.selectedClaimStatus, '', 2);
                                var typeState = $scope.CreateFilterState($scope.claimType, $scope.selectedClaimType, '', 3);
                                var costCentreState = $scope.CreateFilterState($scope.lstCostCentre, $scope.selectedCostCentre, '', 4);

                                $scope.selectedWorkPlaceNumber = ($scope.selectedWorkPlaceNumber.length == 0 ? $scope.allWorkPlaceNumber : $scope.selectedWorkPlaceNumber);
                                $scope.selectedWorkPlaceName = $scope.selectedWorkPlaceName.length == 0 ? $scope.allWorkPlaceName : $scope.selectedWorkPlaceName;
                                $scope.selectedClaimStatus = $scope.selectedClaimStatus.length == 0 ? $scope.claimStatus : $scope.selectedClaimStatus;
                                $scope.selectedClaimType = $scope.selectedClaimType.length == 0 ? $scope.claimType : $scope.selectedClaimType;
                                $scope.selectedCostCentre = $scope.selectedCostCentre.length == 0 ? [] : $scope.selectedCostCentre;
                                $scope.rowPerPage = $rootScope.pageNavigationHistory.claimSumRowPerPage || 10;
                                
                                $scope.getClaimList($scope.employerId, $rootScope.claimsPageSelected, $scope.selectedWorkPlaceNumber, $scope.selectedWorkPlaceName).then(function () {
                                    $scope.BindFilterControl();

                                    $timeout(function () {
                                        $('#workplace-number').multiselect('dataprovider', wpNumberState.LstOption);
                                        $('#workplace-name').multiselect('dataprovider', wpNameState.LstOption);
                                        $('#claim-status').multiselect('dataprovider', statusState.LstOption);
                                        $('#claim-type').multiselect('dataprovider', typeState.LstOption);
                                        $('#cost-centre').multiselect('dataprovider', costCentreState.LstOption);
                                        $('#workplace-number + div  input:text').val(wpNumberState.FilterQuery);
                                        $('#workplace-name + div  input:text').val(wpNameState.FilterQuery);
                                        $scope.BindFilterOptionAfterRefresh();

                                        $scope.stateWPNumberSearch = $rootScope.pageNavigationHistory.stateWPNumberSearch;
                                        $scope.stateWPNameSearch = $rootScope.pageNavigationHistory.stateWPNameSearch;
                                    }, 100);
                                });
                            }
                        });
                    });
                });
            }

            var initClaimStatusTooltip = function () {
                var claimTypeTooltip = '';
                if ($scope.Scheme === 0) { // NSW
                    claimTypeTooltip = '<table style="text-align:left"><tbody>' +
                        '<tr><td>TL</td><td>: Time Lost</td></tr>' +
                        '<tr><td>PI</td><td>: Permanent Impairment</td></tr>' +
                        '<tr><td>FC</td><td>: Fatality Claims</td></tr>' +
                        '<tr><td>MO</td><td>: Medical Only</td></tr>' +
                        '<tr><td>JO</td><td>: Journey</td></tr>' +
                        '<tr><td>RE</td><td>: Recess</td></tr>' +
                        '</tbody></table>';
                } else if ($scope.Scheme === 2) { // VIC
                    claimTypeTooltip = '<table style="text-align:left"><tbody>' +
                        '<tr><td valign="top">MI:</td><td>  Minor Claim <br>  Notification only. A claim for compensation and or medical that has <u>not</u> exceeded the employers excess.</td></tr>' +
                        '<tr><td valign="top">ST:</td><td>  Standard Claim <br>  A claim for compensation and or medicals that has exceeded the employers excess.</td></tr>' +
                        '</tbody></table>';
                }

                $('[data-target="claim-status"][data-toggle="tooltip"]').tooltip({
                    container: 'body',
                    html: true,
                    title: claimTypeTooltip,
                    template: '<div class="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner max-width-tooltip"></div></div>',
                    triggers: 'click hover focus'
                });
            }

            //filterType: 0: WorkPlaceNumber    1: WorkPlaceName,    2: ClaimStatus    3: ClaimType     4: CostCentre
            $scope.CreateFilterState = function (allOption, selectedOption, filterQuery, filterType) {

                var lstOption = [];
                angular.forEach(allOption, function (value, key) {
                    if (filterType === 0)
                        lstOption.push({ label: value.WorkPlaceNumber, value: value.WorkPlaceNumber, selected: false });
                    else if (filterType === 1)
                        lstOption.push({ label: value.WorkPlaceName, value: value.WorkPlaceNumber, selected: false });
                    else if (filterType === 2 || filterType === 3)
                        lstOption.push({ label: value || 'N/A', value: value || '', selected: false });
                    else if (filterType === 4)
                        lstOption.push({ label: value.CostCentreCode + ' - ' + value.CostCentreName, value: value.CostCentreId, selected: false });
                });

                for (var i = 0; i < lstOption.length; i++) {
                    for (var j = 0; j < selectedOption.length; j++) {
                        if (lstOption[i].value == selectedOption[j].WorkPlaceNumber || lstOption[i].value == selectedOption[j]) {
                            lstOption[i].selected = true;
                            break;
                        }
                    }
                }

                return { FilterQuery: filterQuery, LstOption: lstOption };
            }

            //searchbyNumberOrName 
            //true  : search By Number
            //false : search by Name
            $scope.searchWorkPlace = function (query) {
                var deferred = $q.defer();

                var APITarget = "api/vicclaims/getvicclaimworkplace";
                var Values = JSON.stringify({
                    EmployerId: $scope.employerId,
                    Keyword: query
                });

                var options = {
                    beforeSend: function () { },
                    afterSend: function () { }
                };

                httpService.httpRequest(APITarget, Values, 'GET', options).then(function (data) {  // this is only run after $http completes
                    if (data !== false) {
                        if (data === "logout") {
                            $rootScope.userLogout();
                        }
                        $scope.serverResponse = angular.fromJson(data);

                        $scope.allWorkPlace = $scope.serverResponse;

                        deferred.resolve(true);
                    }

                    deferred.reject(false);
                });

                return deferred.promise;
            }

            $scope.getCostCentre = function () {
                return $filter('dec2obj')(sessionStorage.getItem('LstCostCentre'));
            }

            $scope.getClaimStatusAndType = function () {
                var deferred = $q.defer();

                var APITarget = "api/vicclaims/getvicclaimstatusandtype";
                var Values = JSON.stringify({
                    Identifier: $rootScope.user.Identifier,
                    IsClaimant: $rootScope.IsClaimant,
                    PolicyId: $scope.employerId
                });

                httpService.httpRequest(APITarget, Values).then(function (data) {  // this is only run after $http completes
                    if (data !== false) {
                        if (data === "logout") {
                            $rootScope.userLogout();
                        }

                        $scope.serverResponse = angular.fromJson(data);

                        $scope.claimStatus = $scope.serverResponse.ClaimStatus;
                        $scope.claimType = $scope.serverResponse.ClaimType;

                        deferred.resolve(true);
                    }

                    deferred.reject(false);
                });


                return deferred.promise;
            }

            $scope.BindFilterOptionAfterRefresh = function () {
                //Add wording to tooltip of workplace and remove tooltip of claim status and claim type
                $('#workplace-number + div i.multiselect').attr('title', 'Display top 20 items');
                $('#workplace-name + div i.multiselect').attr('title', 'Display top 20 items');
                $('#claim-status + div i.multiselect').attr('title', '');
                $('#claim-type + div i.multiselect').attr('title', '');
                $('#cost-centre + div i.multiselect').attr('title', '');

                //Bind click event for clear search workplace number button
                $('#workplace-number + div  button.multiselect-clear-filter').click(function (event) {
                    $scope.oldWorkPlaceNumberSearch = '';
                    lstWorkPlaceNumber = $scope.stateWPNumberSearch.LstOption;

                    var optionWPNumber = [];
                    angular.forEach($scope.stateWPNumberSearch.LstOption, function (value, key) {
                        optionWPNumber = optionWPNumber.concat(ParseArrayStringToArrayObject(value.value));
                    });

                    $scope.workPlaceNumber = optionWPNumber;
                    $scope.$apply();

                    $timeout(function () {
                        $('#workplace-number').multiselect('dataprovider', lstWorkPlaceNumber);

                        $('#workplace-number + div  input:text').focus();

                        $('#workplace-number + div  input:text').val($scope.oldWorkPlaceNumberSearch);

                        $scope.BindFilterOptionAfterRefresh();
                    }, 50);
                });

                //Bind click event for clear search workplace name button
                $('#workplace-name + div  button.multiselect-clear-filter').click(function (event) {
                    $scope.oldWorkPlaceNameSearch = '';
                    lstWorkPlaceName = $scope.stateWPNameSearch.LstOption;

                    var optionWPName = [];
                    angular.forEach($scope.stateWPNameSearch.LstOption, function (value, key) {
                        optionWPName = optionWPName.concat(ParseArrayStringToArrayObject(value.value));
                    });

                    $scope.workPlaceName = optionWPName;
                    $scope.$apply();

                    $timeout(function () {
                        $('#workplace-name').multiselect('dataprovider', lstWorkPlaceName);

                        $('#workplace-name + div  input:text').focus();

                        $('#workplace-name + div  input:text').val($scope.oldWorkPlaceNameSearch);

                        $scope.BindFilterOptionAfterRefresh();
                    }, 50);
                });

                //only allow numeric in workplace number filter search
                $("#workplace-number + div input:text").on("keypress keyup blur", function (event) {
                    var regex = new RegExp("^[0-9]+$");
                    var key = String.fromCharCode(event.charCode ? event.which : event.charCode);
                    var keyCode = event.which ? event.which : event.keyCode;
                    //prevent backSpace, left and right arrow button
                    if (!regex.test(key) && event.which != 8)
                        event.preventDefault();
                });

                //only allow alphaNum in workplace name filter search
                $("#workplace-name + div input:text").on("keypress keyup blur", function (event) {
                    var regex = new RegExp("^[a-zA-Z0-9\w ]+$");
                    var key = String.fromCharCode(event.charCode ? event.which : event.charCode);
                    var keyCode = event.which ? event.which : event.keyCode;
                    //prevent backSpace, left and right arrow button
                    if (!regex.test(key) && event.which != 8)
                        event.preventDefault();
                });
            }

            $scope.$watch('selectedWorkPlaceNumber', function () {
                if ($scope.oldWorkPlaceNumberSearch == '') {
                    var selectedWPNum = ParseArrayStringToArrayObject($('#workplace-number').val());
                    $scope.stateWPNumberSearch = $scope.CreateFilterState($scope.workPlaceNumber, (selectedWPNum == null || selectedWPNum.length == 0 || selectedWPNum.length > $scope.workPlaceNumber.length) ? [] : selectedWPNum, '', 0);
                }

                if ($scope.oldWorkPlaceNameSearch == '') {
                    var selectedWPName = ParseArrayStringToArrayObject($('#workplace-name').val());
                    $scope.stateWPNameSearch = $scope.CreateFilterState($scope.workPlaceName, (selectedWPName == null || selectedWPName.length == 0 || selectedWPName.length > $scope.workPlaceName.length) ? [] : selectedWPName, '', 1);
                }
            }, 50);

            $scope.$watch('selectedWorkPlaceName', function () {
                if ($scope.oldWorkPlaceNumberSearch == '') {
                    var selectedWPNum = ParseArrayStringToArrayObject($('#workplace-number').val());
                    $scope.stateWPNumberSearch = $scope.CreateFilterState($scope.workPlaceNumber, (selectedWPNum == null || selectedWPNum.length == 0 || selectedWPNum.length > $scope.workPlaceNumber.length) ? [] : selectedWPNum, '', 0);
                }

                if ($scope.oldWorkPlaceNameSearch == '') {
                    var selectedWPName = ParseArrayStringToArrayObject($('#workplace-name').val());
                    $scope.stateWPNameSearch = $scope.CreateFilterState($scope.workPlaceName, (selectedWPName == null || selectedWPName.length == 0 || selectedWPName.length > $scope.workPlaceName.length) ? [] : selectedWPName, '', 1);
                }
            }, 50);


            //searchbyNumberOrName 
            //true  : search By Number
            //false : search by Name
            $scope.clientSearchWorkPlace = function (query, searchByNumberOrName) {
                var result = [];
                //search by Number
                if (searchByNumberOrName) {
                    angular.forEach($scope.allWorkPlaceNumber, function (value, key) {
                        if (value.WorkPlaceNumber.toLowerCase().indexOf(query.toLowerCase()) == 0) {
                            result.push(value);
                        }
                    });
                }
                else { //search by Name
                    angular.forEach($scope.allWorkPlaceName, function (value, key) {
                        if (value.WorkPlaceName.toLowerCase().indexOf(query.toLowerCase()) == 0) {
                            result.push(value);
                        }
                    });
                }

                return result;
            }

            //Input: list workplace Name
            //Output: list corresponse WorkPlace Number
            $scope.GetWorkPlaceNumberByName = function (workPlace) {
                return workPlace;
            }

            //Input: list workplace Number
            //Output: list corresponse WorkPlace Name
            $scope.GetWorkPlaceNameByNumber = function (workPlace) {
                return workPlace;
            }

            $scope.BindFilterControl = function () {
                $timeout(function () {
                    //Build filter Work Place Number
                    $('#workplace-number').multiselect(
                        {
                            disableIfEmpty: true,
                            dropRight: false,
                            includeSelectAllOption: true,
                            enableFiltering: true,
                            enableCaseInsensitiveFiltering: true,
                            selectedClass: '',
                            buttonText: function (ele, checked) {
                                return '';
                            },
                            templates: {
                                button: '<i class="multiselect dropdown-toggle fa fa-filter" data-toggle="dropdown"></a>'
                            },
                            onFiltering: function () {
                                // if ($scope.oldWorkPlaceNumberSearch != this.query) {
                                //     $scope.oldWorkPlaceNumberSearch = this.query;

                                //     var searchResult = $scope.clientSearchWorkPlace($scope.oldWorkPlaceNumberSearch, true);

                                //     if (searchResult.length == 0) {
                                //         $('#workplace-number + div ul li:not(.multiselect-filter)').remove();

                                //         $('#workplace-number + div ul li.multiselect-filter').after("<li><a><label>No results matched</label></a></li>");
                                //     }
                                //     else {
                                //         //Case clear search filter
                                //         if ($scope.oldWorkPlaceNumberSearch == '') {
                                //             lstWorkPlaceNumber = $scope.stateWPNumberSearch.LstOption;
                                //             $scope.isAnyWorkplaceNumber = false;
                                //             var optionWPNumber = [];
                                //             angular.forEach($scope.stateWPNumberSearch.LstOption, function (value, key) {
                                //                 optionWPNumber = optionWPNumber.concat(ParseArrayStringToArrayObject(value.value));
                                //             });

                                //             $scope.workPlaceNumber = optionWPNumber;
                                //             $scope.$apply();
                                //         }
                                //         //Case normal search in filter
                                //         else {
                                //             $scope.workPlaceNumber = searchResult;
                                //             $scope.isAnyWorkplaceNumber = false;
                                //             //let $scope.workPlaceNumber binding into correct scope instead of parrent scope
                                //             $scope.$apply();

                                //             var lstWorkPlaceNumber = [];
                                //             for (var i = 0; i < $scope.workPlaceNumber.length; i++) {
                                //                 lstWorkPlaceNumber.push({ label: $scope.workPlaceNumber[i].WorkPlaceNumber, value: $scope.workPlaceNumber[i].WorkPlaceNumber, selected: false });
                                //             }
                                //         }

                                //         $timeout(function () {
                                //             $('#workplace-number').multiselect('dataprovider', lstWorkPlaceNumber);

                                //             $('#workplace-number + div  input:text').focus();

                                //             $('#workplace-number + div  input:text').val($scope.oldWorkPlaceNumberSearch);

                                //             $scope.BindFilterOptionAfterRefresh();
                                //         }, 50);
                                //     }
                                // }
                            },
                            onChange: function (ele, checked) {
                                $scope.isSearchClaim = true;
                                $scope.selectedWorkPlaceNumber = ParseArrayStringToArrayObject($('#workplace-number').val());
                                $scope.isAnyWorkplaceNumber = $('#workplace-number').val() && $('#workplace-number').val().length > 0;
                                var corresponseWPName = [];
                                var filterSearch = ''

                                //Case de-select the last selected option (deselect all) but without search in filter
                                if (($scope.selectedWorkPlaceNumber == null || $scope.selectedWorkPlaceNumber.length == 0) && $scope.oldWorkPlaceNumberSearch == '') {
                                    $scope.selectedWorkPlaceNumber = $scope.allWorkPlaceNumber;

                                    corresponseWPName = $scope.statsWPNumber[$scope.workPlaceNumber].LstOption;
                                    filterSearch = $scope.statsWPNumber[$scope.workPlaceNumber].FilterQuery;

                                    //Bind Option for Workplace Name filter
                                    $scope.workPlaceName = [];
                                    var selectedWPName = [];

                                    for (var i = 0; i < corresponseWPName.length; i++) {
                                        $scope.workPlaceName = $scope.workPlaceName.concat(ParseArrayStringToArrayObject(corresponseWPName[i].value));
                                        if (corresponseWPName[i].selected == true)
                                            selectedWPName = selectedWPName.concat(ParseArrayStringToArrayObject(corresponseWPName[i].value));
                                    }

                                    var lstWPName = $scope.GetWorkPlaceNameByNumber($scope.selectedWorkPlaceNumber);

                                    if (selectedWPName.length == 0) {
                                        $scope.selectedWorkPlaceName = [];
                                        for (var i = 0; i < lstWPName.length; i++) {
                                            $scope.selectedWorkPlaceName.push(lstWPName[i]);
                                        }
                                    }
                                    else {
                                        $scope.selectedWorkPlaceName = selectedWPName;
                                    }
                                }
                                else {
                                    //Case de-select the last selected option (deselect all) but without search in filter
                                    if ($scope.selectedWorkPlaceNumber == null)
                                        $scope.selectedWorkPlaceNumber = $scope.allWorkPlaceNumber;

                                    var lstWPName = $scope.GetWorkPlaceNameByNumber($scope.selectedWorkPlaceNumber);

                                    //Case select/de-select single Option Or Have search in filter
                                    if ($scope.selectedWorkPlaceNumber.length != $scope.workPlaceNumber.length || $scope.oldWorkPlaceNumberSearch != '') {
                                        for (var i = 0; i < lstWPName.length; i++) {
                                            corresponseWPName.push({ label: lstWPName[i].WorkPlaceName, value: lstWPName[i].WorkPlaceNumber, selected: false });
                                        }
                                        //Save state of filter workplace name for back binding purpose
                                        var wpNumberState = $scope.CreateFilterState($scope.workPlaceNumber, $scope.selectedWorkPlaceNumber, $scope.oldWorkPlaceNumberSearch, 0);
                                        $scope.statsWPName[lstWPName] = wpNumberState;

                                        //Bind Option for Workplace Name filter
                                        $scope.workPlaceName = lstWPName;
                                    }
                                    //Case select the last un-selected option (select all)
                                    else {
                                        corresponseWPName = $scope.statsWPNumber[$scope.selectedWorkPlaceNumber].LstOption;
                                        filterSearch = $scope.statsWPNumber[$scope.selectedWorkPlaceNumber].FilterQuery;

                                        //Bind Option for Workplace Name filter
                                        $scope.workPlaceName = [];
                                        for (var i = 0; i < corresponseWPName.length; i++) {
                                            $scope.workPlaceName = $scope.workPlaceName.concat(ParseArrayStringToArrayObject(corresponseWPName[i].value));
                                        }
                                    }

                                    $scope.selectedWorkPlaceName = lstWPName;
                                }

                                $scope.oldWorkPlaceNameSearch = filterSearch;
                                $scope.$apply();

                                //Wait until the $scope.allWorkPlaceNumber completed render options in DOM
                                $timeout(function () {
                                    $('#workplace-name').multiselect('dataprovider', corresponseWPName);

                                    $('#workplace-name + div  input:text').val(filterSearch);

                                    $scope.BindFilterOptionAfterRefresh();
                                }, 50);

                                $scope.getClaimList($scope.employerId, 1, $scope.selectedWorkPlaceNumber, $scope.selectedWorkPlaceName);
                            },
                            onSelectAll: function (checked) {
                                $scope.isSearchClaim = true;
                                $scope.selectedWorkPlaceNumber = $scope.workPlaceNumber;
                                $scope.isAnyWorkplaceNumber = true;
                                var lstWPName = $scope.GetWorkPlaceNameByNumber($scope.selectedWorkPlaceNumber);

                                var corresponseWPName = [];
                                var filterSearch = ''

                                if ($scope.oldWorkPlaceNumberSearch != '') {
                                    for (var i = 0; i < lstWPName.length; i++) {
                                        corresponseWPName.push({ label: lstWPName[i].WorkPlaceName, value: lstWPName[i].WorkPlaceNumber, selected: false });
                                    }
                                    //Save state of filter workplace name for back binding purpose
                                    var wpNumberState = $scope.CreateFilterState($scope.workPlaceNumber, $scope.selectedWorkPlaceNumber, $scope.oldWorkPlaceNumberSearch, 0);
                                    $scope.statsWPName[lstWPName] = wpNumberState;

                                    //Bind Option for Workplace Name filter
                                    $scope.workPlaceName = lstWPName;
                                }
                                else {
                                    corresponseWPName = $scope.statsWPNumber[$scope.selectedWorkPlaceNumber].LstOption;
                                    filterSearch = $scope.statsWPNumber[$scope.selectedWorkPlaceNumber].FilterQuery;

                                    $scope.workPlaceName = [];
                                    for (var i = 0; i < corresponseWPName.length; i++) {
                                        $scope.workPlaceName = $scope.workPlaceName.concat(ParseArrayStringToArrayObject(corresponseWPName[i].value));
                                    }
                                }

                                $scope.oldWorkPlaceNameSearch = filterSearch;
                                //let $scope.workPlaceName binding into correct scope instead of parrent scope
                                $scope.$apply();

                                $timeout(function () {
                                    $('#workplace-name').multiselect('dataprovider', corresponseWPName);

                                    $('#workplace-name + div  input:text').val(filterSearch);

                                    $scope.BindFilterOptionAfterRefresh();
                                }, 50);


                                //Bind value for selected workplace number filter
                                $scope.selectedWorkPlaceName = [];
                                for (var i = 0; i < corresponseWPName.length; i++) {
                                    $scope.selectedWorkPlaceName = $scope.selectedWorkPlaceName.concat(ParseArrayStringToArrayObject(corresponseWPName[i].value));
                                }


                                $scope.getClaimList($scope.employerId, 1, $scope.selectedWorkPlaceNumber, $scope.selectedWorkPlaceName);
                            },
                            onDeselectAll: function (checked) {
                                $scope.isSearchClaim = true;

                                $scope.selectedWorkPlaceNumber = $scope.allWorkPlaceNumber;
                                $scope.isAnyWorkplaceNumber = false;
                                var lstWPName = $scope.GetWorkPlaceNameByNumber($scope.selectedWorkPlaceNumber);

                                //let $scope.workPlaceName binding into correct scope instead of parrent scope
                                $scope.$apply();

                                if ($('#workplace-name').val() == null || $('#workplace-name').val().length == 0) {
                                    $scope.selectedWorkPlaceName = [];
                                    for (var i = 0; i < lstWPName.length; i++) {
                                        $scope.selectedWorkPlaceName.push(lstWPName[i]);
                                    }
                                }
                                else {
                                    $scope.selectedWorkPlaceName = ParseArrayStringToArrayObject($('#workplace-name').val());
                                }

                                $scope.getClaimList($scope.employerId, 1, $scope.allWorkPlaceNumber, $scope.selectedWorkPlaceName);
                            }
                        });

                    //Build filter Work Place Name
                    $('#workplace-name').multiselect(
                        {
                            disableIfEmpty: true,
                            dropRight: true,
                            includeSelectAllOption: true,
                            enableFiltering: true,
                            enableCaseInsensitiveFiltering: true,
                            selectedClass: '',
                            buttonText: function (ele, checked) {
                                return '';
                            },
                            templates: {
                                button: '<i class="multiselect dropdown-toggle fa fa-filter" data-toggle="dropdown"></a>'
                            },
                            onFiltering: function () {
                                // if ($scope.oldWorkPlaceNameSearch != this.query) {
                                //     $scope.oldWorkPlaceNameSearch = this.query;

                                //     var searchResult = $scope.clientSearchWorkPlace($scope.oldWorkPlaceNameSearch, false);

                                //     if (searchResult.length == 0) {
                                //         $('#workplace-name + div ul li:not(.multiselect-filter)').remove();

                                //         $('#workplace-name + div ul li.multiselect-filter').after("<li><a><label>No results matched</label></a></li>");
                                //     }
                                //     else {
                                //         //Case clear search filter
                                //         if ($scope.oldWorkPlaceNameSearch == '') {
                                //             lstWorkPlaceName = $scope.stateWPNameSearch.LstOption;
                                //             $scope.isAnyWorkplaceName = false;
                                //             var optionWPName = [];
                                //             angular.forEach($scope.stateWPNameSearch.LstOption, function (value, key) {
                                //                 optionWPName = optionWPName.concat(ParseArrayStringToArrayObject(value.value));
                                //             });

                                //             //$scope.workPlaceName = optionWPName;
                                //             $scope.$apply();
                                //         }
                                //         //Case normal search in filter
                                //         else {
                                //             //$scope.workPlaceName = searchResult;
                                //             $scope.isAnyWorkplaceName = false;
                                //             //let $scope.workPlaceNumber binding into correct scope instead of parrent scope
                                //             $scope.$apply();

                                //             var lstWorkPlaceName = [];
                                //             for (var i = 0; i < $scope.workPlaceName.length; i++) {
                                //                 lstWorkPlaceName.push({ label: $scope.workPlaceName[i].WorkPlaceName, value: $scope.workPlaceName[i].WorkPlaceNumber, selected: false });
                                //             }
                                //         }

                                //         // $timeout(function () {
                                //         //     $('#workplace-name').multiselect('dataprovider', lstWorkPlaceName);

                                //         //     $('#workplace-name + div  input:text').focus();

                                //         //     $('#workplace-name + div  input:text').val($scope.oldWorkPlaceNameSearch);

                                //         //     $scope.BindFilterOptionAfterRefresh();
                                //         // }, 50);
                                //     }
                                // }
                            },
                            onChange: function (ele, checked) {
                                $scope.isSearchClaim = true;
                                $scope.selectedWorkPlaceName = ParseArrayStringToArrayObject($('#workplace-name').val());
                                $scope.isAnyWorkplaceName = $('#workplace-name').val() && $('#workplace-name').val().length > 0;
                                var corresponseWPNumber = [];
                                var filterSearch = ''

                                //Case de-select the last selected option (deselect all) but without search in filter
                                if (($scope.selectedWorkPlaceName == null || $scope.selectedWorkPlaceName.length == 0) && $scope.oldWorkPlaceNameSearch == '') {
                                    $scope.selectedWorkPlaceName = $scope.allWorkPlaceName;

                                    corresponseWPNumber = $scope.statsWPName[$scope.workPlaceName].LstOption;
                                    filterSearch = $scope.statsWPName[$scope.workPlaceName].FilterQuery;

                                    //Bind Option for Workplace Number filter
                                    $scope.workPlaceNumber = [];
                                    var selectedWPNum = [];
                                    for (var i = 0; i < corresponseWPNumber.length; i++) {
                                        $scope.workPlaceNumber = $scope.workPlaceNumber.concat(ParseArrayStringToArrayObject(corresponseWPNumber[i].value));
                                        if (corresponseWPNumber[i].selected == true)
                                            selectedWPNum = selectedWPNum.concat(ParseArrayStringToArrayObject(corresponseWPNumber[i].value));
                                    }

                                    var lstWPNumber = $scope.GetWorkPlaceNumberByName($scope.selectedWorkPlaceName);

                                    if (selectedWPNum.length == 0) {
                                        $scope.selectedWorkPlaceNumber = [];
                                        for (var i = 0; i < lstWPNumber.length; i++) {
                                            $scope.selectedWorkPlaceNumber.push(lstWPNumber[i]);
                                        }
                                    }
                                    else {
                                        $scope.selectedWorkPlaceNumber = selectedWPNum;
                                    }

                                } else {
                                    //Case de-select the last selected option (deselect all) but with search in filter
                                    if ($scope.selectedWorkPlaceName == null || $scope.selectedWorkPlaceName.length == 0)
                                        $scope.selectedWorkPlaceName = $scope.allWorkPlaceName;

                                    var lstWPNumber = $scope.GetWorkPlaceNumberByName($scope.selectedWorkPlaceName);

                                    //Case select/de-select single Option OR Have search in filter
                                    if ($scope.selectedWorkPlaceName.length != $scope.workPlaceName.length || $scope.oldWorkPlaceNameSearch != '') {
                                        for (var i = 0; i < lstWPNumber.length; i++) {
                                            corresponseWPNumber.push({ label: lstWPNumber[i].WorkPlaceNumber, value: lstWPNumber[i].WorkPlaceNumber, selected: false });
                                        }
                                        //Save state of filter workplace number for back binding purpose
                                        var wpNameState = $scope.CreateFilterState($scope.workPlaceName, $scope.selectedWorkPlaceName, $scope.oldWorkPlaceNameSearch, 1);
                                        $scope.statsWPNumber[lstWPNumber] = wpNameState;
                                        
                                        //Bind Option for Workplace Number filter
                                        $scope.workPlaceNumber = lstWPNumber;
                                    }
                                    //Case select the last un-selected option (select all)
                                    else {
                                        corresponseWPNumber = $scope.statsWPName[$scope.selectedWorkPlaceName].LstOption;
                                        filterSearch = $scope.statsWPName[$scope.selectedWorkPlaceName].FilterQuery;

                                        //Bind Option for Workplace Number filter
                                        $scope.workPlaceNumber = [];
                                        for (var i = 0; i < corresponseWPNumber.length; i++) {
                                            $scope.workPlaceNumber = $scope.workPlaceNumber.concat(ParseArrayStringToArrayObject(corresponseWPNumber[i].value));
                                        }
                                    }

                                    $scope.selectedWorkPlaceNumber = lstWPNumber;
                                }

                                $scope.oldWorkPlaceNumberSearch = filterSearch;
                                $scope.$apply();

                                //Wait until the $scope.allWorkPlaceNumber completed render options in DOM
                                $timeout(function () {
                                    $('#workplace-number').multiselect('dataprovider', corresponseWPNumber);

                                    $('#workplace-number + div  input:text').val(filterSearch);

                                    $scope.BindFilterOptionAfterRefresh();
                                }, 50);

                                $scope.getClaimList($scope.employerId, 1, $scope.selectedWorkPlaceNumber, $scope.selectedWorkPlaceName);
                            },
                            onSelectAll: function (checked) {
                                $scope.isSearchClaim = true;
                                $scope.selectedWorkPlaceName = $scope.workPlaceName;
                                $scope.isAnyWorkplaceName = true;
                                var lstWPNumber = $scope.GetWorkPlaceNumberByName($scope.selectedWorkPlaceName);

                                var corresponseWPNumber = [];
                                var filterSearch = ''

                                if ($scope.oldWorkPlaceNameSearch != '') {
                                    for (var i = 0; i < lstWPNumber.length; i++) {
                                        corresponseWPNumber.push({ label: lstWPNumber[i].WorkPlaceNumber, value: lstWPNumber[i].WorkPlaceNumber, selected: false });
                                    }
                                    //Save state of filter workplace name for back binding purpose
                                    var wpNameState = $scope.CreateFilterState($scope.workPlaceName, $scope.selectedWorkPlaceName, $scope.oldWorkPlaceNameSearch, 1);
                                    $scope.statsWPNumber[lstWPNumber] = wpNameState;

                                    //Bind Option for Workplace Name filter
                                    $scope.workPlaceNumber = lstWPNumber;
                                }
                                else {
                                    corresponseWPNumber = $scope.statsWPName[$scope.selectedWorkPlaceName].LstOption;
                                    filterSearch = $scope.statsWPName[$scope.selectedWorkPlaceName].FilterQuery;

                                    $scope.workPlaceNumber = [];
                                    for (var i = 0; i < corresponseWPNumber.length; i++) {
                                        $scope.workPlaceNumber = $scope.workPlaceNumber.concat(ParseArrayStringToArrayObject(corresponseWPNumber[i].value));
                                    }
                                }

                                $scope.oldWorkPlaceNumberSearch = filterSearch;

                                $scope.$apply();

                                $timeout(function () {
                                    $('#workplace-number').multiselect('dataprovider', corresponseWPNumber);

                                    $('#workplace-number + div  input:text').val(filterSearch);

                                    $scope.BindFilterOptionAfterRefresh();
                                }, 50);

                                $scope.selectedWorkPlaceNumber = [];
                                for (var i = 0; i < corresponseWPNumber.length; i++) {
                                    $scope.selectedWorkPlaceNumber = $scope.selectedWorkPlaceNumber.concat(ParseArrayStringToArrayObject(corresponseWPNumber[i].value));
                                }

                                $scope.getClaimList($scope.employerId, 1, $scope.selectedWorkPlaceNumber, $scope.selectedWorkPlaceName);
                            },
                            onDeselectAll: function (checked) {
                                $scope.isSearchClaim = true;
                                $scope.selectedWorkPlaceName = $scope.allWorkPlaceName;
                                $scope.isAnyWorkplaceName = false;
                                var lstWPNumber = $scope.GetWorkPlaceNumberByName($scope.selectedWorkPlaceName);

                                $scope.$apply();

                                if ($('#workplace-number').val() == null || $('#workplace-number').val().length == 0) {
                                    $scope.selectedWorkPlaceNumber = [];
                                    for (var i = 0; i < lstWPNumber.length; i++) {
                                        $scope.selectedWorkPlaceNumber.push(lstWPNumber[i]);
                                    }
                                }
                                else {
                                    $scope.selectedWorkPlaceNumber = ParseArrayStringToArrayObject($('#workplace-number').val());
                                }

                                $scope.getClaimList($scope.employerId, 1, $scope.selectedWorkPlaceNumber, $scope.selectedWorkPlaceName);
                            }
                        });

                    //Build filter Claim Status
                    $('#claim-status').multiselect(
                        {
                            dropRight: true,
                            includeSelectAllOption: true,
                            selectedClass: '',
                            buttonText: function (ele, checked) {
                                return '';
                            },
                            templates: {
                                button: '<i class="multiselect dropdown-toggle fa fa-filter" data-toggle="dropdown"></a>',
                            },
                            onChange: function (ele, checked) {
                                $scope.isSearchClaim = true;
                                $scope.selectedClaimStatus = $('#claim-status').val();
                                $scope.isAnyStatusSelected = $('#claim-status').val() && $('#claim-status').val().length > 0;
                                if ($scope.selectedClaimStatus == null || $scope.selectedClaimStatus.length == 0) {
                                    $scope.selectedClaimStatus = $scope.claimStatus;
                                }

                                $scope.getClaimList($scope.employerId, 1, $scope.selectedWorkPlaceNumber, $scope.selectedWorkPlaceName);
                            },
                            onSelectAll: function (checked) {
                                $scope.isSearchClaim = true;
                                $scope.isAnyStatusSelected = true;
                                $scope.selectedClaimStatus = $scope.claimStatus;
                                $scope.getClaimList($scope.employerId, 1, $scope.selectedWorkPlaceNumber, $scope.selectedWorkPlaceName);
                            },
                            onDeselectAll: function (checked) {
                                $scope.isSearchClaim = true;
                                $scope.isAnyStatusSelected = false;
                                $scope.selectedClaimStatus = $scope.claimStatus;
                                $scope.getClaimList($scope.employerId, 1, $scope.selectedWorkPlaceNumber, $scope.selectedWorkPlaceName);
                            }
                        });

                    //Build filter Claim Type
                    $('#claim-type').multiselect(
                        {
                            dropRight: true,
                            includeSelectAllOption: true,
                            selectedClass: '',
                            buttonText: function (ele, checked) {
                                return '';
                            },
                            templates: {
                                button: '<i class="multiselect dropdown-toggle fa fa-filter" data-toggle="dropdown"></a>',
                            },
                            onChange: function (ele, checked) {
                                $scope.isSearchClaim = true;
                                $scope.selectedClaimType = $('#claim-type').val();
                                $scope.isAnyTypeSelected = $('#claim-type').val() && $('#claim-type').val().length > 0;
                                if ($scope.selectedClaimType == null) {
                                    $scope.selectedClaimType = $scope.claimType;
                                }

                                $scope.getClaimList($scope.employerId, 1, $scope.selectedWorkPlaceNumber, $scope.selectedWorkPlaceName);
                            },
                            onSelectAll: function (checked) {
                                $scope.isSearchClaim = true;
                                $scope.isAnyTypeSelected = true;
                                $scope.selectedClaimType = $scope.claimType;
                                $scope.getClaimList($scope.employerId, 1, $scope.selectedWorkPlaceNumber, $scope.selectedWorkPlaceName);
                            },
                            onDeselectAll: function (checked) {
                                $scope.isSearchClaim = true;
                                $scope.isAnyTypeSelected = false;
                                $scope.selectedClaimType = $scope.claimType;
                                $scope.getClaimList($scope.employerId, 1, $scope.selectedWorkPlaceNumber, $scope.selectedWorkPlaceName);
                            }
                        });

                    //Build filter Cost Centre
                    $('#cost-centre').multiselect(
                        {
                            dropRight: true,
                            includeSelectAllOption: true,
                            selectedClass: '',
                            buttonText: function (ele, checked) {
                                return '';
                            },
                            templates: {
                                button: '<i class="multiselect dropdown-toggle fa fa-filter" data-toggle="dropdown"></a>',
                            },
                            onChange: function (ele, checked) {
                                $scope.isSearchClaim = true;
                                $scope.selectedCostCentre = $('#cost-centre').val();

                                if ($scope.selectedCostCentre == null || $scope.selectedCostCentre.length == 0) {
                                    $scope.selectedCostCentre = [];
                                }

                                $scope.getClaimList($scope.employerId, 1, $scope.selectedWorkPlaceNumber, $scope.selectedWorkPlaceName);
                            },
                            onSelectAll: function (checked) {
                                $scope.isSearchClaim = true;
                                $scope.selectedCostCentre = [];
                                $scope.getClaimList($scope.employerId, 1, $scope.selectedWorkPlaceNumber, $scope.selectedWorkPlaceName);
                            },
                            onDeselectAll: function (checked) {
                                $scope.isSearchClaim = true;
                                $scope.selectedCostCentre = [];
                                $scope.getClaimList($scope.employerId, 1, $scope.selectedWorkPlaceNumber, $scope.selectedWorkPlaceName);
                            }
                        });

                    $scope.BindFilterOptionAfterRefresh();

                }, 100);
            }

            $scope.searchClaim = function () {
                $scope.isSearchClaim = true;
                if ($scope.claimSearchString === $scope.resultMessage) {
                    return;
                }
                $scope.resultMessage = $scope.claimSearchString;
                $scope.getClaimList($scope.employerId, 1, $scope.selectedWorkPlaceNumber, $scope.selectedWorkPlaceName);
            };

            $scope.AddSuffixToWorkPlaceNumber = function (lstWorkPlaceNumber) {
                var lstWorkPlaceNumberWithBusienssUnitSuffix = [];

                //Add business unit suffix into lstWorkPlaceNumber (WorkPlace Id)
                for (var i = 0; i < lstWorkPlaceNumber.length; i++) {
                    lstWorkPlaceNumberWithBusienssUnitSuffix.push(lstWorkPlaceNumber[i] + $scope.VicBusinessUnitSuffix);
                }

                return lstWorkPlaceNumberWithBusienssUnitSuffix
            }

            $scope.getClaimList = function (employerId, num, lstWorkPlaceNumber, lstWorkPlaceName) {
                var deferred = $q.defer();

                $rootScope.claimsPageSelected = num;

                var workPlaceNumber = [];
                var workPlaceName = [];

                angular.forEach(lstWorkPlaceNumber, function (value, key) {
                    workPlaceNumber.push(value.WorkPlaceNumber);
                });

                angular.forEach(lstWorkPlaceName, function (value, key) {
                    workPlaceName.push(value.WorkPlaceName);
                });

                for (var i = 0; i < $scope.selectedClaimType.length; i++) {
                    if ($scope.selectedClaimType[i] === '') {
                        $scope.selectedClaimType[i] = null;
                    }
                }

                for (var i = 0; i < $scope.selectedCostCentre.length; i++) {
                    if ($scope.selectedCostCentre[i] === '') {
                        $scope.selectedCostCentre[i] = null;
                    }
                }


                $scope.claimSearchString = $filter('undefined')($scope.claimSearchString) ? "" : $scope.claimSearchString;
                var APITarget = "api/vicclaims/getvicclaimpagecount";
                var Values = JSON.stringify({
                    Identifier: $rootScope.user.Identifier,
                    SessionKey: $filter('decstr64')($rootScope.user.SessionKey),
                    DateOfBirth: ($rootScope.user.DateOfBirth),
                    EmployerId: employerId,
                    LstWorkPlaceNumber: $scope.AddSuffixToWorkPlaceNumber(workPlaceNumber),
                    LstWorkPlaceName: workPlaceName,
                    LstClaimStatus: $scope.selectedClaimStatus,
                    LstClaimType: $scope.selectedClaimType,
                    LstCostCentre: $scope.selectedCostCentre,
                    Keyword: $scope.claimSearchString,
                    RowsPerPage: $scope.rowPerPage,
                    PageNumber: num,
                    IsClaimant: $rootScope.IsClaimant
                });

                httpService.httpRequest(APITarget, Values).then(function (data) {  // this is only run after $http completes
                    if (data !== false) {
                        if (data === "logout") {
                            $rootScope.userLogout();
                        }
                        $scope.serverResponse = angular.fromJson(data);
                        $scope.ClaimCount = $scope.serverResponse.PageCount;
                        $rootScope.claimSummaryTotalClaims = $scope.serverResponse.RowsCount;
                        $scope.ClaimPageCount = {
                            EmployerId: $scope.employerId,
                            Pages: []
                        };
                        var counterPage = 0;
                        for (var i = 0; i < $scope.ClaimCount; i++) {
                            counterPage++;
                            $scope.ClaimPageCount.Pages.push(counterPage);
                        }
                        $scope.Claims = $scope.serverResponse.Data;
                        if ($scope.Claims.length > 0) {
                            $rootScope.pageName = "My Claims Summary";
                        }

                        deferred.resolve(true);
                    }

                    deferred.reject(false);
                });


                return deferred.promise;
            };


            $scope.selectRow = function(rowPerPage) {
                $scope.rowPerPage = rowPerPage;
                $scope.getClaimList($scope.employerId, 1, $scope.allWorkPlaceNumber, $scope.allWorkPlaceName).then(function () {
                    $scope.BindFilterControl();
                });
            }           

            $scope.goToPage = function (pageNumber) {
                $rootScope.claimsPageSelected = pageNumber;

                $scope.claimSearchString = $filter('undefined')($scope.claimSearchString) ? "" : $scope.claimSearchString;

                var workPlaceNumber = [];
                var workPlaceName = [];

                angular.forEach($scope.selectedWorkPlaceNumber, function (value, key) {
                    workPlaceNumber.push(value.WorkPlaceNumber);
                });

                angular.forEach($scope.selectedWorkPlaceName, function (value, key) {
                    workPlaceName.push(value.WorkPlaceName);
                });

                var APITarget = "api/vicclaims/getvicclaimsummary";
                var Values = JSON.stringify({
                    Identifier: $rootScope.user.Identifier,
                    SessionKey: $filter('decstr64')($rootScope.user.SessionKey),
                    DateOfBirth: $rootScope.user.DateOfBirth,
                    EmployerId: $scope.employerId,
                    LstWorkPlaceNumber: $scope.AddSuffixToWorkPlaceNumber(workPlaceNumber),
                    LstWorkPlaceName: workPlaceName,
                    LstClaimStatus: $scope.selectedClaimStatus,
                    LstClaimType: $scope.selectedClaimType,
                    Keyword: $scope.claimSearchString,
                    RowsPerPage: $scope.rowPerPage,
                    PageNumber: pageNumber,
                    IsClaimant: $rootScope.IsClaimant
                });

                httpService.httpRequest(APITarget, Values).then(function (data) {  // this is only run after $http completes
                    if (data !== false) {
                        if (data === "logout") {
                            $rootScope.userLogout();
                        }
                        $scope.serverResponse = angular.fromJson(data);
                        $scope.Claims = $scope.serverResponse;
                        if (document.getElementById("goToPageByInput")) {
                            document.getElementById("goToPageByInput").value = pageNumber;
                        }

                    }
                });
            }

            $scope.goToPageByInput = function (numberOfPage) {
                if (numberOfPage == "" || numberOfPage == 0 || numberOfPage > $scope.ClaimPageCount.Pages.length) {
                    return;
                }
                $scope.numberOfPage = parseInt(numberOfPage);
                $scope.goToPage($scope.numberOfPage);
            }

            //set disable Go button
            $scope.buttonGoDisabled = true;
            $scope.setVisibleButton = function (numberOfPage) {
                $scope.numberOfPage = "";
                if (!(numberOfPage == "" || numberOfPage == 0 || numberOfPage > $scope.ClaimPageCount.Pages.length)) {
                    $scope.buttonGoDisabled = false;
                }
                else {
                    $scope.buttonGoDisabled = true;
                }
                $scope.numberOfPage = numberOfPage;
            }

            $scope.exportClaimSummary = function () {

                var workPlaceNumber = [];
                var workPlaceName = [];

                angular.forEach($scope.allWorkPlaceNumber, function (value, key) {
                    workPlaceNumber.push(value.WorkPlaceNumber);
                });

                angular.forEach($scope.allWorkPlaceName, function (value, key) {
                    workPlaceName.push(value.WorkPlaceName);
                });

                var APITarget = "api/vicclaims/exportclaimexcelfile";
                var Values = JSON.stringify({
                    Identifier: $rootScope.user.Identifier,
                    SessionKey: $filter('decstr64')($rootScope.user.SessionKey),
                    DateOfBirth: $rootScope.user.DateOfBirth,
                    Keyword: "",
                    LstWorkPlaceNumber: $scope.AddSuffixToWorkPlaceNumber(workPlaceNumber),
                    LstWorkPlaceName: workPlaceName,
                    LstClaimStatus: $scope.claimStatus,
                    LstClaimType: $scope.claimType,
                    EmployerId: $scope.employerId,
                    RowsPerPage: 2147483647, //max integer number in c#
                    PageNumber: 1,
                    Jurisdiction: $rootScope.getSelectedJurisdiction()
                });

                var options = { responseType: 'arraybuffer' };
                httpService.httpRequest(APITarget, Values, 'GET', options).then(function (data) {  // this is only run after $http completes
                    if (angular.isDefined(data.File)) {
                        var file = new Blob([data.File], { type: 'text/csv' });
                        var fileName = '';
                        if ($rootScope.user.IsClaimant) {
                            fileName = 'ClaimSummary' + '_' + $rootScope.user.DisplayName.trim().replace(/ /g, '') + '_' + commonService.formatDate(new Date()) + '.csv'
                        }
                        else {
                            fileName = ($scope.policy.BusinessUnit === 0 ? 'icareNSW' : 'WorkSafeVictoria')
                                + '_ClaimsSummary_'
                                + ($scope.policy.PolicyNumber ? $scope.policy.PolicyNumber.trim() : '') + '_'
                                + commonService.formatDate(new Date()) + '.csv';
                        }
                        saveAs(file, fileName);
                        return true;
                    }
                    else
                        return false;
                });
            };



            $scope.viewClaimDetail = function (claim) {
                $rootScope.pageNavigationHistory.claim = claim;

                //store status of filter in case of back navigator
                $rootScope.pageNavigationHistory.claimSearchString = $scope.claimSearchString;

                $rootScope.pageNavigationHistory.statsWPNumber = $scope.statsWPNumber;
                $rootScope.pageNavigationHistory.statsWPName = $scope.statsWPName;

                $rootScope.pageNavigationHistory.workPlaceNumber = $scope.workPlaceNumber;
                $rootScope.pageNavigationHistory.workPlaceName = $scope.workPlaceName;

                $rootScope.pageNavigationHistory.selectedWorkPlaceNumber =
                    ($('#workplace-number').val() == null || $('#workplace-number').val() == undefined)
                        ? [] : ParseArrayStringToArrayObject($('#workplace-number').val());

                $rootScope.pageNavigationHistory.selectedWorkPlaceName =
                    ($('#workplace-name').val() == null || $('#workplace-name').val() == undefined)
                        ? [] : ParseArrayStringToArrayObject($('#workplace-name').val());

                $rootScope.pageNavigationHistory.selectedClaimStatus =
                    ($('#claim-status').val() == null || $('#claim-status').val() == undefined)
                        ? [] : $('#claim-status').val();

                $rootScope.pageNavigationHistory.selectedClaimType =
                    ($('#claim-type').val() == null || $('#claim-type').val() == undefined)
                        ? [] : $('#claim-type').val();

                $rootScope.pageNavigationHistory.selectedCostCentre =
                    ($('#cost-centre').val() == null || $('#cost-centre').val() == undefined)
                        ? [] : $('#cost-centre').val();

                $rootScope.pageNavigationHistory.stateWPNumberSearch = $scope.stateWPNumberSearch;
                $rootScope.pageNavigationHistory.stateWPNameSearch = $scope.stateWPNameSearch;

                $rootScope.pageNavigationHistory.oldWorkPlaceNumberSearch = $scope.oldWorkPlaceNumberSearch;
                $rootScope.pageNavigationHistory.oldWorkPlaceNameSearch = $scope.oldWorkPlaceNameSearch;
                $rootScope.pageNavigationHistory.claimSumRowPerPage = $scope.rowPerPage;
            };

            function ParseArrayStringToArrayObject(workplace) {
                workplace = workplace || [];

                if (typeof (workplace) === 'string') {
                    workplace = [workplace];
                }

                var ret = [];

                angular.forEach(workplace, function (selectedWP, key) {
                    angular.forEach($scope.allWorkPlace, function (allWP, key) {
                        if (allWP.WorkPlaceNumber == selectedWP) {
                            ret.push(allWP);
                        }
                    });
                });

                return ret;
            }
        }]);
